import { render, staticRenderFns } from "./AddFotoBranchComponent.vue?vue&type=template&id=131b9c5d&scoped=true"
import script from "./AddFotoBranchComponent.vue?vue&type=script&lang=js"
export * from "./AddFotoBranchComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131b9c5d",
  null
  
)

export default component.exports